<script>
export default {
    props: ['value', 'placeholder'],
    name: "datePicker",
    data() {
        return {
            valueChooseDay: null,
            today: this.formatTime(new Date()),
            weeks: ['日', '一', '二', '三', '四', '五', '六'],
            year: null,
            month: null,
            day: null,
            firstDayWeek: null,
            lastDayWeek: null,
            days: 0,
            // prevDays: 0,
            prev: null,
            next: null,
            isShowPopup: false,
            isTapValue: false,
        };
    },
    computed: {},
    components: {},
    mounted() {
        window.addEventListener('click', this.handleClick);
    },
    destroyed() {
        window.removeEventListener('click', this.handleClick)
    },
    watch: {
        year: 'init',
        month: 'init',
        value: {
            handler: function (value) { 
                let date = value ? value.split('-') : this.today;
                this.year = date[0];
                this.month = value ? date[1] - 1 : date[1];
                this.day = date[2];
                this.valueChooseDay = value ? [this.year, this.month, this.day] : null;
            },
            immediate: true
        }
    },
    methods: {
        handleClick() { 
            if (this.isTapValue) { 
                this.isTapValue = false;
                return;
            }
            this.isShowPopup = false;
        },
        formatTime(date) {
            const year = date.getFullYear();
            const month = date.getMonth();
            const day = date.getDate();
            return [year, month, day];
        },
        init() {
            // 第一天周几
            this.firstDayWeek = new Date(this.year, this.month, 1).getDay();
            // 这个月最后一天
            let lastDate = new Date(this.year, this.month + 1, 0);
            this.days = lastDate.getDate(); // 这个月天数
            this.lastDayWeek = lastDate.getDay(); //最后一天周几
            // 上个月
            let prevMonth = new Date(this.year, this.month, 0);
            this.prev = {
                year: prevMonth.getFullYear(),
                month: prevMonth.getMonth(),
                days: prevMonth.getDate()
            }
            // 下个月
            let nextMonth = new Date(this.year, this.month + 1, 1);
            this.next = {
                year: nextMonth.getFullYear(),
                month: nextMonth.getMonth(),
                // days: nextMonth.getDate()
            }
        },
        prevYear(event) {
            event.stopPropagation();
            this.year--;
        },
        nextYear(event) {
            event.stopPropagation();
            this.year++;
        },
        prevMonth(event) {
            event.stopPropagation();
            if (this.month <= 0) { 
                this.year--;
                this.month = 11;
            } else {
                this.month--;
            }
        },
        nextMonth(event) {
            event.stopPropagation();
            if (this.month >= 11) { 
                this.year++;
                this.month = 0;
            } else {
                this.month++;
            }
        },
        choose(event, year, month, day) { 
            event.stopPropagation();
            this.isShowPopup = false;
            const value = `${year}-${month + 1}-${day}`;
            this.$emit('input', value);
            this.$emit('change', value);
        },
        tapValue(event) {
            // event.stopPropagation();
            this.isShowPopup = !this.isShowPopup;
            this.isTapValue = true;
        },
        tapPopup(event) { 
            event.stopPropagation();
        },
    },
};
</script>

<template>
    <div class="date_picker">
        <div class="value flex flex_colunm align_center justify_between" :class="{active: isShowPopup}" @click="tapValue">
            <span v-if="value">{{ value }}</span>
            <span v-else-if="placeholder">{{ placeholder }}</span>
            <span v-else>请选择日期</span>
        </div>
        <div class="popup" v-if="isShowPopup" @click="tapPopup">
            <div class="top flex align_center">
                <div class="btn prev year" @click="prevYear"></div>
                <div class="btn prev month" @click="prevMonth"></div>
                <p class="text">{{ year }}年{{ month + 1 }}月</p>
                <div class="btn next month" @click="nextMonth"></div>
                <div class="btn next year" @click="nextYear"></div>
            </div>
            <div class="weeks flex">
                <div class="item" v-for="(item, index) in weeks" :key="index">{{ item }}</div>
            </div>
            <div class="calendar flex flex_wrap">
                <!-- 上个月 -->
                <div class="item other" v-for="(item, index) in firstDayWeek" :key="`prev${index}`"
                @click="choose($event, prev.year, prev.month, prev.days - firstDayWeek + index + 1)">{{ prev.days - firstDayWeek + index + 1 }}</div>
                <!-- 这个月 -->
                <div class="item" :class="{
                    is_today: year == today[0] && month == today[1] && index + 1 == today[2],
                    is_check: valueChooseDay ? (valueChooseDay[0] == year && valueChooseDay[1] == month && valueChooseDay[2] == index + 1) : false
                }" 
                v-for="(item, index) in days" :key="index"
                @click="choose($event, year, month, index + 1)">{{ index + 1 }}</div>
                <!-- 下个月 -->
                <div class="item other" v-for="(item, index) in 6 - lastDayWeek" :key="`next${index}`"
                @click="choose($event, next.year, next.month, index + 1)">{{ index + 1 }}</div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.date_picker{
    min-width: 1.7rem;
    position: relative;
    z-index: 9;
    white-space: nowrap;
    display: inline-block;
    .value{
        height: .4rem;
        font-size: .18rem;
        border: 1px solid #000;
        padding: 0 .15rem;
        cursor: pointer;
        user-select: none;
        box-sizing: content-box;
        &::after{
            content: '';
            display: block;
            width: .1rem;
            height: .1rem;
            border: 1px solid #000;
            border-width: 0 1px 1px 0;
            transform: translate(0, -25%) rotate(45deg);
        }
        &.active{
            &::after{
                transform: translate(0, 25%) rotate(-135deg);
            }
        }
    }
    .popup{
        background: #fff;
        border: 1px solid #000;
        position: absolute;
        top: calc(100% + .1rem);
        left: 0;
        padding: 0 .1rem .1rem;
        user-select: none;
        .top{
            font-size: .2rem;
            .text{
                flex: 1;
                text-align: center;
            }
            .btn{
                width: .4rem;
                height: .4rem;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                &::before,
                &::after{
                    content: "";
                    display: block;
                    width: .06rem;
                    height: .06rem;
                    border: 1px solid #000;
                    border-width: 1px 1px 0 0;
                    transform: rotate(45deg);
                }
                &.prev{
                    &::before,
                    &::after{
                        transform: rotate(-135deg);
                    }
                }
                &.month{
                    &::after{
                        display: none;
                    }
                }
            }
        }
        .weeks,
        .calendar{
            font-size: .2rem;
            text-align: center;
            line-height: .5rem;
            .item{
                width: .5rem;
                height: .5rem;
            }
        }
        .weeks{
            border-bottom: 1px solid #d3d3d3;
        }
        .calendar{
            .item{
                cursor: pointer;
                &.other{
                    color: #999;
                }
                &.is_today{
                    font-weight: bold;
                    text-decoration: underline;
                }
                &:hover,
                &.is_check{
                    background: #000;
                    color: #fff;
                }
            }
        }
    }
}
</style>